'use client';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import Link from 'next/link';

import ExternalLink from '@/components/ui/external-link';

export default function Header({ homeHref = '/' }: { homeHref?: string } = {}) {
  return (
    <header className="w-full bg-white shadow-gray-400 shadow-xs">
      <div className="container mx-auto flex items-center justify-between px-4 py-4">
        <div className="flex items-center">
          <Link href={homeHref} className="w-48">
            <Image
              src="/assets/images/aareal-aval.png"
              alt="Aareal Aval Logo"
              width={2081}
              height={507}
              className="mr-4"
            />
          </Link>
        </div>
        <div className="flex items-center">
          <ExternalLink href="tel:+4902115426856" className="font-semibold text-sm">
            <FontAwesomeIcon icon={faPhone as IconProp} className="mr-2" />
            02115426856
          </ExternalLink>
        </div>
      </div>
    </header>
  );
}
